import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Contacts extends React.Component {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    domain: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Duration)', name: 'duration', type: 'numberfield', required: true, defaultValue: 1, units: 'years'  },
            { label: 't(Auto Renew)', name: 'auto_renew', type: 'checkbox', prompt: 't(Auto renew this domain)', defaultValue: true },
            { label: 't(Transfer Lock)', name: 'is_locked', type: 'checkbox', prompt: 't(Lock this domain against transfers)', defaultValue: true }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(domain) {
    this.setState({ domain })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(domain) {
    this.props.onSave(domain)
  }

}

export default Contacts
